export const altimInHgToQNH = (altimInHg) => {
  const qnh = Math.round((altimInHg * 1013.25) / 29.92);
  return qnh;
};
